import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { AlertTriangle } from 'lucide-react'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Badge } from '@/components/ui/badge'
import { submittalStatusVariant } from '@/lib/status-variants'
import type { CostContractSubmittal } from '../types'

interface Props { projectId: string; submittals: CostContractSubmittal[] }

/** Integrations spec §2.5: a warning only — the approval stays possible. Nothing when every linked submittal is settled. */
const PendingSubmittalsAlert: React.FC<Props> = ({ projectId, submittals }) => {
  const { t } = useTranslation()
  if (!submittals.length) return null
  return (
    <Alert>
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>{t('CostControl_submittals_pending_title')}</AlertTitle>
      <AlertDescription>
        <p className="mb-2">{t('CostControl_submittals_pending_text')}</p>
        <ul className="flex flex-wrap gap-2">
          {submittals.map((s) => (
            <li key={s.id} className="flex items-center gap-1.5 text-sm">
              {s.canOpen
                ? <Link to={`/project/${projectId}/submittals/${s.id}`} className="text-primary hover:underline">{s.displayNumber} {s.title}</Link>
                : <span>{s.displayNumber} {s.title}</span>}
              <Badge variant={submittalStatusVariant(s.status)}>{t(`Submittal_status_${s.status}`)}</Badge>
            </li>
          ))}
        </ul>
      </AlertDescription>
    </Alert>
  )
}
export default PendingSubmittalsAlert
